import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const FullWrapper = styled.div`
  width: 100%;
  background-color: ${props => props.bgColor};
  padding: ${props => props.padding};
`;

export const Wrapper = styled.div`
  width: 100%;
`;
export const Container = styled.div`
  width: 100%;
  background-color: ${props => props.bgColor};
  padding: 10px 0;
`;

export const NavContainer = styled.nav`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  gap: 40px;
`;

export const Navbar = styled.ul`
  width: 100%;
  display: flex;
  justify-content: space-between;
  max-width: 400px;
  font-size: 13px;
  line-height: 20px;
  color: #0d0e43;
  margin-right: auto;

  @media (max-width: 1200px) {
    display: none;
  }
`;
export const NavItem = styled(NavLink)`
  list-style-type: none;
  color: #0d0e43;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &::after {
    content: url("/svgs/arrow_red.svg");
    width: 16px;
    height: 16px;
    margin-left: 5px;
    position: relative;
    top: -2px;
    visibility: hidden;
  }

  &:hover,
  &.current {
    color: #fb2e86;

    &::after {
      visibility: visible;
    }
  }
`;

export const Logo = styled.a`
  font-size: 2.125rem;
  line-height: 1;
  font-weight: 700;
  font-family: "Josefin Sans", sans-serif;
  color: #0d0e43;
`;

export const SearchBox = styled.div`
  width: 320px;
  height: 40px;
  position: relative;
`;
export const Box = styled.div`
  background-color: #fb2e86;
  padding: 15px;
  width: 40px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const SearchInput = styled.input`
  height: 100%;
  width: 100%;
  padding-left: 20px;
  border: 1px solid #e7e6ef;
`;
